export class SaleOfferDepartureSerialNumber {
  constructor(
    public hash?: string,
    public serialNumber?: string,
    public saleOfferLineHash?: string,
    public saleOfferLineType?: number,
    public saleOfferLineProductName?: string,
    public saleOfferLineProductCode?: string,
    public saleOfferLineProductDescription?: string,
    public saleOfferLineProductNeedSerialNumber?: boolean,
    public saleOfferLineComplementName?: string,
    public saleOfferLineComplementCode?: string,
    public saleOfferLineComplementDescription?: string,
    public saleOfferLineComplementNeedSerialNumber?: boolean
  ) { }

  clone() {
    return new SaleOfferDepartureSerialNumber(
      this.hash,
      this.serialNumber,
      this.saleOfferLineHash,
      this.saleOfferLineType,
      this.saleOfferLineProductName,
      this.saleOfferLineProductCode,
      this.saleOfferLineProductDescription,
      this.saleOfferLineProductNeedSerialNumber,
      this.saleOfferLineComplementName,
      this.saleOfferLineComplementCode,
      this.saleOfferLineComplementDescription,
      this.saleOfferLineComplementNeedSerialNumber
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-departure-serial-number.ts